import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import cx from 'classnames'

import DropDownMenuItem from './components/DropDownMenuItem'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class DropDownMenu extends Component {
    static propTypes = {
        closeDropdownMenu: PropTypes.func.isRequired,
        items: PropTypes.array.isRequired,
        name: PropTypes.string.isRequired,
        open: PropTypes.bool.isRequired,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        toggleDropdownMenu: PropTypes.func.isRequired,
    }

    onClickHandler = () => {
        const { name, toggleDropdownMenu } = this.props

        toggleDropdownMenu(name)
    }

    onMouseLeaveHandler = () => {
        const { name, closeDropdownMenu } = this.props

        closeDropdownMenu(name)
    }

    render() {
        const { closeDropdownMenu, items, name, open, text } = this.props

        const itemElements = _.map(items, (item, index) => {
            const callback = _.get(item, 'callback.func', () => {})
            const params = _.get(item, 'callback.params', [])

            const callbackWrap = () => {
                callback(...params)
                closeDropdownMenu(name)
            }

            return <DropDownMenuItem key={index} icon={item.icon} text={item.text} callback={callbackWrap} />
        })

        return (
            <div className={cx('drop-down', name)} onMouseLeave={this.onMouseLeaveHandler}>
                <div className={'drop-down__main'} onClick={this.onClickHandler}>
                    {text}
                </div>
                <div className={cx('drop-down__menu', open && 'open')}>{itemElements}</div>
            </div>
        )
    }
}
